// @flow

/**
 * @property {Object[]} studiesList
 * @property {number} currentPage
 * @property {number} rowsPerPage
 * @property {boolean} isNextPageAvailable
 */
export default class Manager {
  studiesList: Array<Object> = [];

  currentPage: number = 0;

  rowsPerPage: number = 25;

  pageOptions: Array<number> = [10, 25, 50, 100];

  isNextPageAvailable: boolean = false;

  totalStudies: number = 0;

  filters: Object = null;

  isRaim: Boolean = null;

  selectedPacsIndex: ?number = null;
}
